import { Component, OnInit, inject } from '@angular/core';
import { PostTradeService } from '../../post-trade.service';
import { CaseManagementService } from '../../../case-management/case-management.service';
import { TradeGridSummaryResponse } from '../../../models/post-trade-models';

@Component({
  selector: 'app-trade-review-dashboard',
  templateUrl: './trade-review-dashboard.component.html',
  styleUrls: ['./trade-review-dashboard.component.scss'],
  standalone: false,
})
export class TradeReviewDashboardComponent implements OnInit {
  private ptSvc = inject(PostTradeService);
  cms = inject(CaseManagementService);

  agingCases = [];
  openRecords = {};

  ngOnInit(): void {
    this.ptSvc.loading.set(true);
    this.cms
      .getCaseManagementData({
        search: {
          profileValues: {
            StatusName: 'Assigned',
            Type: ['Trade', 'TradeGroup'],
          },
        },
        take: 10,
        sort: {
          DateLastUpdated: 'asc',
        },
      })
      .subscribe(resp => {
        if (resp['data']) {
          this.agingCases = resp['data'];
        }

        if (this.ptSvc.loading()) {
          this.ptSvc.loading.set(false);
        }
      });

    this.ptSvc
      .getTradeGridSummary()
      .subscribe((resp: TradeGridSummaryResponse) => {
        if (resp.data) {
          this.openRecords = resp.data[0];
        }

        if (this.ptSvc.loading()) {
          this.ptSvc.loading.set(false);
        }
      });
  }
}
